import React from 'react'

import {
  FAILED,
  NOT_WATERMARKED,
  PROCESSING,
  WATERMARK_REMOVED,
  WATERMARKED,
} from '@disco/constants/WatermarkStatusesTypes'
import { Trans } from '@disco/i18n/trans'

import ContactUsLink from 'components/ui/contact-us-link'
import type { IconKey } from 'components/ui/icon'
import type { LozengeColor } from 'components/ui/lozenge'

import type { Translate } from './types'

const trackOptions: {
  failed: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
    tooltip: React.ReactNode
  }
  not_watermarked: (t: Translate) => {
    color: LozengeColor
    icon: IconKey
    text: string
    tooltip: React.ReactNode
  }
  processing: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
    tooltip: string
  }
  watermark_removed: (t: Translate) => {
    color: LozengeColor
    strikethrough: boolean
    text: string
    shortText: string
    tooltip: string
  }
  watermarked: (t: Translate) => {
    color: LozengeColor
    text: string
    shortText: string
  }
} = {
  [WATERMARKED](t) {
    return {
      color: 'blue',
      text: t('common:watermarked', 'Watermarked'),
      shortText: t('common:watermarkedAbbreviation', 'W'),
    }
  },

  [WATERMARK_REMOVED](t) {
    return {
      color: 'yellow',
      strikethrough: true,
      text: t('common:watermarked', 'Watermarked'),
      shortText: t('common:watermarkedAbbreviation', 'W'),
      tooltip: t(
        'common:thisTrackWasWatermarkedPreviously',
        'This track was watermarked previously but is currently not watermarked in any playlists.',
      ),
    }
  },

  [NOT_WATERMARKED](t) {
    return {
      color: 'yellow',
      icon: 'warning',
      text: t('common:notWatermarked', 'Not watermarked'),
      tooltip: (
        <Trans
          t={t}
          i18nKey="common:thisTrackIsNotWatermarkedInThisPlaylist"
          defaults="This track is not watermarked in this playlist.<more>Find out more</more>"
          components={{
            more: <a className="WatermarkingStatusFlag_Link" href="#" />,
          }}
        />
      ),
    }
  },

  [FAILED](t) {
    return {
      color: 'bold-red',
      text: t('common:failed', 'Failed'),
      shortText: t('common:failedAbbreviation', 'F'),
      tooltip: (
        <Trans
          t={t}
          i18nKey="common:watermarkingForThisTrackFailed"
          defaults="Watermarking for this track failed. Please <contact>contact us</contact> for assistance"
          components={{
            contact: (
              <ContactUsLink intercomMsg="I’m having issues with watermarking failing on a track" />
            ),
          }}
        />
      ),
    }
  },

  [PROCESSING](t) {
    return {
      color: 'bold-green',
      text: t('common:processing', 'Processing'),
      shortText: t('common:processingAbbreviation', 'P'),
      tooltip: t(
        'common:watermarkingForThisTrackIsStillInProgress',
        'Watermarking for this track is still in progress.',
      ),
    }
  },
}
export default trackOptions
